import React from "react";
import { Spin } from "antd";

interface TableLoadingPlaceholderProps {
  label?: string;
}

// Same visual treatment as the roads & sewers rate-library loading state
// (DrainageRunMatrix.tsx/SectionMatrixTable.tsx) - reused here as the
// shared placeholder for useTableRenderDeferral()'s brief pre-mount defer.
const TableLoadingPlaceholder: React.FC<TableLoadingPlaceholderProps> = ({
  label = "Loading table data...",
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "80px 0",
      gap: 16,
    }}
  >
    <Spin size="large" />
    <span style={{ color: "#6b7280", fontSize: 14 }}>{label}</span>
  </div>
);

export default TableLoadingPlaceholder;
